import React from "react";
import {
    Alert,
    Backdrop,
    Box,
    CircularProgress,
    Paper,
    Stack,
    Typography
} from "@mui/material";

const CheckoutBackdrop = ({
    open,
    title = "Redirecting...",
    description = "Please wait while we prepare your secure checkout session.",
    selectedItem,
    selectedItemLabel = "Selected Plan",
    redirectText = "Redirecting to payment provider...",
    providerName = "Chargebee"
}) => {
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 999,
                background: "rgba(252,252,252,0.55)",
                backdropFilter: "blur(8px)"
            }}
        >
            <Box
                sx={{
                    width: { xs: "90%", sm: 500 },
                    p: 4,
                    borderRadius: 4,
                    bgcolor: "background.paper",
                    border: (theme) =>
                        `1px solid ${theme.palette.primary.light}`,
                    boxShadow: "0 20px 60px rgba(0,0,0,0.08)"
                }}
            >
                <Stack spacing={2} alignItems="center">
                    <CircularProgress
                        size={56}
                        sx={{
                            color: (theme) => theme.palette.primary.main
                        }}
                    />

                    <Typography variant="h3" fontWeight={700}>
                        {title}
                    </Typography>

                    <Typography
                        color="text.secondary"
                        textAlign="center"
                    >
                        {description}
                    </Typography>
                </Stack>

                <Paper
                    elevation={0}
                    sx={{
                        mt: 4,
                        p: 3,
                        borderRadius: 3,
                        bgcolor: (theme) =>
                            theme.palette.secondary.light,
                        border: (theme) =>
                            `1px solid ${theme.palette.secondary.main}`
                    }}
                >
                    <Stack spacing={2}>
                        {selectedItem && (
                            <Typography>
                                ✓ {selectedItemLabel}: {selectedItem}
                            </Typography>
                        )}

                        <Typography>
                            ✓ Creating secure checkout session
                        </Typography>

                        <Typography
                            sx={{
                                color: (theme) =>
                                    theme.palette.primary.main,
                                fontWeight: 600
                            }}
                        >
                            ⟳ {redirectText}
                        </Typography>
                    </Stack>
                </Paper>

                <Alert
                    severity="info"
                    sx={{
                        mt: 3,
                        borderRadius: 2
                    }}
                >
                    Your payment is secured and processed through{" "}
                    {providerName}.
                </Alert>
            </Box>
        </Backdrop>
    );
};

export default CheckoutBackdrop;